import React from 'react'
import PropTypes from 'prop-types'

const Button = (props) => (
  <button onClick={props.onClick} style={{padding: '1rem 1rem', backgroundColor: '#ffc621s'}} className={`${'btn d-flex align-items-center'} ${props.smaller ? 'btn--smaller' : ''} ${props.campaign ? 'btn--campaign' : ''} ${props.ghost ? 'btn--ghost' : ''} ${props.centered ? 'mx-auto' : ''}`}>
    <strong className="text-uppercase" style={{ color: 'rgba(0,0,0,.66)'}}>{props.children}</strong>
    {props.icon ? <i className="material-icons" style={{ marginLeft: '0.5rem' }} aria-hidden="true">{props.icon}</i> : null}
  </button>
)

Button.propTypes = {
  campaign: PropTypes.bool,
  icon: PropTypes.string,
  centered: PropTypes.bool,
  ghost: PropTypes.bool,
  onClick: PropTypes.func,
  smaller: PropTypes.bool,
  children: PropTypes.node,
}

export default Button



// WEBPACK FOOTER //
// ./client/components/Button.js